export default "__VITE_ASSET__sbzF8cQY__"